import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./addschedule-modal.html';
import moment from 'moment-timezone';
import FormatterCommon from '../../app/data-formatters/formatter-common';
import '../../app/bindings/ko-qtip2';
import 'moment-timezone';
import 'knockstrap';
import 'knockout.validation';
import PreferenceService from '../../services/preference.service';
import LoginService from "../../services/login.service";

function ScheduleModal(params) {
    var self = this;

    ko.validation.rules.pattern.message = 'Invalid entry';

    ko.validation.init({
        registerExtenders: true,
        messagesOnModified: true,
        insertMessages: true,
        parseInputAttributes: true,
        messageTemplate: null
    }, true);

    self.panels = params.panels;
    self.fixedPanels = params.fixedPanels;

    self.dataProvider = params.dataProvider;
    self.enablePdf = params.pdf && self.dataProvider.isPdfEnabled()
    self.queryParams = params.queryParams;
    self.appId = params.appId;
    self.widgetQueryId = self.queryId = params.queryId; // queryId set as paramater on the widget

    self.frequencies = ko.observableArray(params.frequencies ? params.frequencies.split(',') : ['Once', 'Daily', 'Weekly', 'Monthly']);

    self.showExcel = (self.appId === 'historical2' || self.appId === 'rooms');

    self.shareName = params.shareName;
    self.viewId = params.viewId;
    self.tabId = params.tabId; //observable UI-1357

    // the following commented lines can be uncommented to restrict export emails to the org's domain emails
    //var email = LoginService.userObject.email;
    //var orgDomain = LoginService.userObject.orgDomain;

    self.emailpattern = "^([^\\s@]+@[^\\s@]+\\.[^\\s@]+,?\\s?)+$";//"^([\\w+-.%]+@[\\w-.]+\\.[A-Za-z]{2,4},?\\s?)+$";
    self.emailRegex = new RegExp(self.emailpattern);

    self.subscriptions = [];

    self.scheduleEnabled = true;

    self.isSaving = ko.observable(false);

    self.ciscoSparkSpaces = ko.observableArray([]);
    self.selectedSpaceIds = ko.observableArray([]);

    self.subject = ko.observable('').extend({ required: true });
    var defaultRecipients = LoginService.userObject.email === 'support@vyopta.com' ? '' : LoginService.userObject.email;
    self.recipients = ko.observable(defaultRecipients).extend({ required: { onlyIf: function () { return self.selectedSpaceIds().length === 0; } } });
    self.messageText = ko.observable('');
    self.selectedExportTypes = ko.observableArray([]);

    var yearToDateLabel = self.isGov() ? 'Federal Fiscal Year to date' : 'Year to date';
    var defaultReportingPeriodsForOnce = ['Selected', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Last 90 days', 'Previous Week', 'Previous Month',
                                            'Week to date', 'Month to date', 'Quarter to date', yearToDateLabel];
    var reportingPeriodsForOnce = params.reportingPeriodsOnce ? params.reportingPeriodsOnce.split(',') : defaultReportingPeriodsForOnce;
    var reportingPeriodsForSchedule = params.reportingPeriods ? params.reportingPeriods.split(',') : params.reportingPeriodsOnce || defaultReportingPeriodsForOnce.slice(1, 11);

    self.reportingPeriods = ko.observableArray(reportingPeriodsForOnce);
    self.reportingPeriod = ko.observable();

    self.frequency = ko.observable();

    self.eaiTooltipText = ko.observable('Reports are sent to the Custom File Interface location configured in the Admin Portal.');
    self.deliveryMethod = ko.observable('email');
    self.eaiMode = ko.observable(false);
    self.fileName = ko.observable().extend({
      required: { onlyIf: function() { return self.eaiMode(); } },
      pattern: {
        message: 'File Name must contain only letters, numbers, underscores (_), and hyphens (-)',
        params: /^[\w-]+$/
      }
    });

    self.saveAllowed = ko.computed(function() {
      return !self.isSaving() &&
        (
          (!self.eaiMode() && (!_.isEmpty(self.selectedSpaceIds()) || self.emailRegex.test(self.recipients())) && !_.isEmpty(self.subject())) ||
          (self.eaiMode() && !_.isEmpty(self.fileName()))
        );
    });

    self.startDate = ko.observable();
    self.sendTime = ko.observable('08:00');

    self.timezone = moment.tz.guess();
    self.timezoneAbbr = moment().tz(moment.tz.guess()).zoneAbbr();

    self.scheduleMode = ko.observable(false);
    self.scheduleModeText = ko.observable('Schedule');

    self.dailyVisible = ko.observable(false);
    self.weeklyVisible = ko.observable(false);
    self.monthlyVisible = ko.observable(false);
    self.onceMessageVisible = ko.observable(false);

    self.emailDeliveryMessage = ko.pureComputed(function () {
        var message;

        if (self.onceMessageVisible()) {
          if (self.eaiMode()) {
            message = 'The file will be created in a few minutes';
          } else {
            message = 'Recipients will receive an email in a few minutes';
          }
        }
        else if (self.dailyVisible()) {
          if (self.eaiMode()) {
            message = 'The file will be created around 8 AM daily';
          } else {
            message = 'Recipients will receive an email around 8 AM daily';
          }
        }
        else if (self.weeklyVisible()) {
          if (self.eaiMode()) {
            message = 'The file will be created around 8 AM on the day(s) selected';
          } else {
            message = 'Recipients will receive an email around 8 AM on the day(s) selected';
          }
        }
        else if (self.monthlyVisible()) {
          if (self.eaiMode()) {
            message = 'The file will be created around 8 AM on the day selected above';
          } else {
            message = 'Recipients will receive an email around 8 AM on the day selected above';
          }
        }
        return message;
    });

    self.hasEmailDeliveryMessage = ko.pureComputed(function () {
        return !_.isEmpty(self.emailDeliveryMessage());
    });

    self.monthOption = ko.observable('specifiedDay');

    self.weekNumber = ko.observable(1);
    self.days = getDayOptions();
    self.selectedDays = ko.observableArray(_.range(1,6).map(String)); // ["1", "2", ..., "5"]
    self.availableDays = ko.observableArray([
        { letter: 'S', value: 0 },
        { letter: 'M', value: 1 },
        { letter: 'T', value: 2 },
        { letter: 'W', value: 3 },
        { letter: 'T', value: 4 },
        { letter: 'F', value: 5 },
        { letter: 'S', value: 6 }
    ]);

    self.dailyVisible =         ko.pureComputed(function () { return self.frequency() === 'Daily'; });
    self.monthlyVisible =       ko.pureComputed(function () { return self.frequency() === 'Monthly'; });
    self.weeklyVisible =        ko.pureComputed(function () { return self.frequency() === 'Weekly'; });
    self.onceMessageVisible =   ko.pureComputed(function () { return self.frequency() === 'Once'; });

    self.saveButtonText = ko.pureComputed(function () { return self.onceMessageVisible() ? 'Send' : 'Save'; });

    self.monthWeeks = getMonthWeekOptions();
    self.selectedMonthWeek = ko.observable(1);

    self.dates = getDateOptions();
    self.monthDayNumber = ko.observable(1);
    self.selectedMonthWeekDay = ko.observable(1);

    self.currentScheduleObject = null;

    self.multiSelectInitOptions = {
        includeSelectAllOption: true,
        numberDisplayed: 7,
        nonSelectedText: "(none)",
        buttonClass: 'btn btn-primary',
        maxHeight: 200
    };

    self.subscriptions.push(self.deliveryMethod.subscribe(function(newVal) {
      if (newVal === 'eai') {
        self.selectedExportTypes(['csv']);
        self.eaiMode(true);
      } else {
        self.selectedExportTypes(['xlsx', 'link']);
        self.eaiMode(false);
      }
    }))

    self.subscriptions.push(self.frequency.subscribe(function(newvalue) {
        if (self.skipDefaultValues) {
            return;
        }
        self.reportingPeriods(reportingPeriodsForSchedule);

        if (newvalue === 'Weekly') {
            self.reportingPeriod('Last 7 days');
        }

        if (newvalue === 'Monthly') {
            self.reportingPeriod('Last 30 days');
        }

        if (newvalue === 'Daily') {
            self.reportingPeriod('Last 7 days');
        }

        if (newvalue === 'Once') {
            self.reportingPeriods(reportingPeriodsForOnce);
            self.reportingPeriod('Selected');
        }
    }));

    self.subscriptions.push(self.reportingPeriod.subscribe(function() {
        if (self.skipDefaultValues) {
            return;
        }
        self.subject(self.buildSubject());
        self.messageText(self.buildMessage());
    }));

    self.editMode = false;

    $("#ScheduleModal").on('show.bs.modal', function() {
        if (!self.editMode) {
            self.initialize();
        }
        self.editMode = false;
    });

    self.errors = ko.validation.group(self);
}

ScheduleModal.prototype = {
    isGov: function() {
        return window.Config.isGov;
    },

    getScheduleObject: function(params) {
        var self = this;

        //scheduleDays: [1,2,3,4,5,6,7], frequency: 'all', severity: '', format: 'HTML', template: '<>', enabled: true},
        var scheduleObj = self.currentScheduleObject ? self.currentScheduleObject : {};

        scheduleObj.name = self.eaiMode() ? self.fileName() : self.subject();

        //New format section
        scheduleObj.notifications = [];

        if (self.recipients() && !self.eaiMode()) {
            scheduleObj.notifications.push({
                channel: 'email',
                details: { recipients: self.recipients(), message: self.messageText(), subject: self.subject() }
            });
        }

        if (self.eaiMode() && self.fileName()) {
          scheduleObj.notifications.push({
            channel: 'eai',
            fileName: self.fileName()
          });
        }

        //New format
        scheduleObj.exportTypes = self.selectedExportTypes();
        //New format
        if (scheduleObj.exportTypes.indexOf('image') < 0) {
            scheduleObj.exportTypes.push('image');
        }

        scheduleObj.reportingPeriod = self.reportingPeriod();
        scheduleObj.frequency = self.frequency();

        scheduleObj.timeZone = self.timezone;
        scheduleObj.startDate = self.scheduleMode() ? self.startDate() : moment().format('YYYY/MM/DD');
        scheduleObj.sendTime = self.sendTime();

        scheduleObj.monthOption = self.monthOption();
        scheduleObj.weekNumber = self.weekNumber();
        scheduleObj.selectedDays = self.selectedDays().map(Number);
        scheduleObj.selectedMonths = _.range(1, 13); // [1,2,...,12]
        scheduleObj.monthDayNumber = self.monthDayNumber();
        scheduleObj.selectedMonthWeek = self.selectedMonthWeek();
        scheduleObj.selectedMonthWeekDay = self.selectedMonthWeekDay();

        if (!self.currentScheduleObject) {
            scheduleObj.url = getCleanUrl();
            scheduleObj.category = self.appId;

            scheduleObj._id = null;
            scheduleObj.id = new Date().valueOf();
            scheduleObj.orgId = LoginService.userObject.orgId;
            scheduleObj.createdDateTime = new Date();

            scheduleObj.createdByUserId = "#userId"; //will be replaced by save org prefs

            scheduleObj.createdByName = LoginService.userObject.name;
            scheduleObj.createdByEmail = LoginService.userObject.username;
            scheduleObj.token = null;

            //New format
            scheduleObj.dataSourceId = self.shareName ? self.shareName : self.queryId;
            scheduleObj.queryIdForParams = self.queryId;
        }

        //handling a scenario created by test data: missing create dates (not likely in production)
        if (!scheduleObj.createdDateTime) {
            scheduleObj.createdDateTime = new Date();
            scheduleObj.createdByUserId = "#userId";
            scheduleObj.createdByName = LoginService.userObject.name;
            scheduleObj.createdByEmail = LoginService.userObject.username;
        }

        scheduleObj.modifiedDateTime = new Date();

        //New format
        scheduleObj.modifiedByUserId = "#userId"; //will be replaced by save org prefs

        scheduleObj.modifiedByName = LoginService.userObject.name;
        scheduleObj.modifiedByEmail = LoginService.userObject.username;

        scheduleObj.enabled = self.scheduleEnabled;

        //since edit is done on the reports page, we don't have the right width and height, so params are null; we don't want to mess with pagedata in edit
        if (params) {
            // fix new format panels to play nice with old format
            if (params.tabprefs) {
                let panels = [];
                Object.values(self.panels()).forEach(function (panel) {
                    if (_.has(panel, 'params.observableOptions')) {
                        let options = _.merge({}, panel.params.observableOptions());
                        let obsparams = GetObservableParamsList(panel);
                        panels.push(GetOptionToSave(panel, options, obsparams));
                    }
                });
                params.tabprefs.panels = panels;
            }

            scheduleObj.pageData = { Width: $(document).width(), Height: $(document).height(), Params: params };
        }

        return scheduleObj;
    },

    getParams: function() {
        var self = this;

        if (!self.currentScheduleObject) {
            var qparams = self.queryParams ? self.queryParams() : {};

            if (self.viewId) {
                return PreferenceService.getTab(self.appId, self.viewId, ko.unwrap(self.tabId))
                  .then(function(tabprefs) {
                    if (tabprefs && (tabprefs.panels !== null) && (_.keys(tabprefs.panels).length > 0)) {
                        qparams.tabprefs = tabprefs;
                    }
                    return qparams;
                });
            } else {
                return Promise.resolve(qparams);
            }
        } else {
            return Promise.resolve(null);
        }
    },

    saveSchedule: function(skipvalidation) {
        var self = this;

        self.isSaving(true);

        var numerrors = self.errors().length;
        if (skipvalidation || (numerrors === 0)) {

            self.getParams().then(function (params) {
                var editMode = self.currentScheduleObject && (self.currentScheduleObject._id || (self.currentScheduleObject.id && (self.currentScheduleObject.id > -1)));
                var scheduleObject = self.getScheduleObject(params);

                let panels = _.values(_.get(scheduleObject, 'pageData.Params.tabprefs.panels'));
                if (params && params.tabprefs &&
                    _.isEmpty(panels) ||
                    _.some(panels, p => (p.params) ?
                        _.isEmpty(p.params.observableParams[0]) :
                        _.isEmpty(p.observableParams[0]))) {
                  try {
                    console.warn('At least one of the panels is missing data necessary to create a Report. Please reload the page and try again.', scheduleObject);
                    self.dataProvider.logActivity2('savingExportSchedule', 'addschedule-modal.js', 'trying to save report with empty observableParams', scheduleObject);
                  } catch (e) {
                    console.warn('trying to save report with empty observableParams, and error trying to log activity.');
                  }
                  self.isSaving(false);
                  $("#ScheduleModal").modal('hide');
                  alert("At least one of the panels is missing data necessary to create a Report. Please reload the page and try again.");
                  return;
                }

                self.dataProvider.logActivity2('savingExportSchedule', '', '', scheduleObject);

                var promise = editMode ?
                    self.dataProvider.updateExportRegistration(self.appId, { exportRegistration: scheduleObject }) :
                    self.dataProvider.addExportRegistration(self.appId, { exportRegistration: scheduleObject });

                promise.then(function () {
                    $("#ScheduleModal").modal('hide');
                })
                .catch(function(error) {
                    let msg = error.message;
                    self.dataProvider.logActivity2('scheduleSaveFailure', '', 'Failed to add export registration', { errorMsg: msg });
                    console.log(JSON.stringify({ errorMsg: msg }));
                    alert("An error occurred while attempting to save the export request. Please try again.");
                    self.isSaving(false);
                });

            })
            .catch(function(error) {
                let msg = error.message;
                self.isSaving(false);
                self.dataProvider.logActivity2('scheduleSaveFailure', '', 'Failed to get params', {errorMsg: msg});
                console.log(JSON.stringify({ errorMsg: msg }));
                alert("An error occurred while attempting to save the export request. Please try again.");
            });
        }
        else {
          self.isSaving(false);
          self.errors.showAllMessages();
        }
    },

    setScheduleForEdit: function(scheduleObj) {
        var self = this;

        self.errors.showAllMessages(false);
        self.isSaving(false); // reset

        // we're loading a schedule for editing, ignore any default values. We're setting this as is.
        self.skipDefaultValues = true;

        if (scheduleObj._id || (scheduleObj.id && (scheduleObj.id > -1))) {
            self.dataProvider.logActivity2('settingExportScheduleForEdit', '', '', scheduleObj);
        }

        self.editMode = true;

        self.currentScheduleObject = !scheduleObj._id && (!scheduleObj.id || (scheduleObj.id === -1)) ? null : scheduleObj;

        // set queryId from the object we're editing or default to the queryId set on the widget
        self.queryId = scheduleObj.dataSourceId || scheduleObj.queryId || self.widgetQueryId;

        if (!self.queryId) {
            throw new Error('queryId is empty');
        }

        if (scheduleObj.notifications && scheduleObj.notifications.length) {
            var emailnotif = _.find(scheduleObj.notifications, function(notifitem) {
                return notifitem.channel === "email";
            });
            var eainotif = _.find(scheduleObj.notifications, function(notifitem) {
                return notifitem.channel === "eai";
            })
            if (emailnotif && emailnotif.details) {
                self.recipients(emailnotif.details.recipients);
                self.subject(emailnotif.details.subject);
                self.messageText(emailnotif.details.message);
            }

            if (eainotif && eainotif.fileName) {
              self.eaiMode(true);
              self.deliveryMethod('eai');
              self.fileName(eainotif.fileName);
            } else {
              self.eaiMode(false);
              self.deliveryMethod('email');
              self.fileName('');
            }
        }
        else {
            self.recipients(scheduleObj.recipients);
            self.subject(scheduleObj.name);
            self.messageText(scheduleObj.messageText);
            self.eaiMode(false);
            self.deliveryMethod('email');
            self.fileName('');
        }

        self.selectedExportTypes(sanitize(scheduleObj.exportTypes || scheduleObj.fileTypes));

        self.frequency(sanitize(scheduleObj.frequency));
        self.reportingPeriod(sanitize(scheduleObj.reportingPeriod));

        self.scheduleMode(scheduleObj.frequency !== "Once");
        self.scheduleModeText(self.scheduleMode() ? 'Once' : 'Schedule');

        self.startDate(sanitize(scheduleObj.startDate));
        self.sendTime(sanitize(scheduleObj.sendTime));

        self.scheduleEnabled = sanitize(scheduleObj.enabled);

        self.monthOption(sanitize(scheduleObj.monthOption));
        self.weekNumber(sanitize(scheduleObj.weekNumber));
        self.selectedDays(sanitize(scheduleObj.selectedDays.map(String)));
        self.monthDayNumber(sanitize(scheduleObj.monthDayNumber));
        self.selectedMonthWeek(sanitize(scheduleObj.selectedMonthWeek));
        self.selectedMonthWeekDay(sanitize(scheduleObj.selectedMonthWeekDay));

        // we're done setting the schedule for editing, allow default values for any user selections
        self.skipDefaultValues = false;
    },

    removeSchedule: function(scheduleObj, callback) {
        var self = this;
        self.dataProvider.logActivity2('removingExportSchedule', 'Schedule Grid', '', scheduleObj);
        self.dataProvider.deleteExportRegistration(self.appId, scheduleObj._id || scheduleObj.id).finally(function () {
            callback();
        });
    },

    buildSubject: function(freq, rep) {
        var self = this;

        if (!self.shareName && !self.queryId) {
            // we're likely editing (shareName and queryId are provided by views that allow creation of exports)
            // In the Reports page we just edit reports so these values are empty
            return '';
        }

        var frequency = freq ? freq : self.frequency();
        var repPeriod = rep ? rep : self.reportingPeriod();
        var name = self.shareName ? self.shareName : splitCamelCase(self.queryId);

        var result = (frequency === 'Once' ? "" : frequency) + " " + name + " Report" + (repPeriod === 'Selected' ? "" : " for " + repPeriod);

        return result;
    },

    buildMessage: function(freq, rep) {
        var self = this;

        if (!self.shareName && !self.queryId) {
            // we're likely editing (shareName and queryId are provided by views that allow creation of exports)
            // In the Reports page we just edit reports so these values are empty
            return '';
        }

        var frequency = freq ? freq : self.frequency();
        var repPeriod = rep ? rep : self.reportingPeriod();

        var name = self.shareName ? self.shareName : splitCamelCase(self.queryId);

        var result = (frequency === 'Once' ? "" : frequency) + " " + name + " Report" + (repPeriod === 'Selected' ? "" : " for " + repPeriod);

        if (self.queryParams) {
            var paramObj = self.queryParams();

            if (paramObj) {
                var comp = [];

                if (paramObj.webexSiteName) {
                    comp.push("Webex Site: " + paramObj.webexSiteName);
                }
                if (paramObj.hierarchyPath) {
                    comp.push("Hierarchy: " + paramObj.hierarchyPath);
                }

                if (paramObj.WhereConditionObj && paramObj.WhereConditionObj.length === 1 && paramObj.WhereConditionObj[0].conditions.length === 1) {
                    var cond = paramObj.WhereConditionObj[0].conditions[0];
                    var valuename = cond.valuename && (cond.valuename.length > 0) ? cond.valuename[0] : null;
                    var rhs = valuename ? valuename : cond.rhsText;
                    var optitle = cond.optitle;

                    if (cond.selectedRhs && (cond.selectedRhs.length > 0)) {
                        if (cond.selectedRhs.length === 1) {
                            rhs = valuename ? valuename : cond.selectedRhs[0];
                            optitle = "is";
                        }
                        else {
                            rhs = cond.selectedRhs.length + " selected values";
                        }
                    }

                    if (!cond.lhstitle) {
                        cond.lhstitle = cond.selectedLhs;
                    }

                    if (!optitle) {
                        optitle = cond.selectedOperator;
                    }

                    comp.push("Criterion: " + cond.lhstitle + " " + optitle + " " + rhs);
                }
                if (comp.length > 0) {
                    result = result + " [ " + comp.join(" - ") + " ]";
                }
            }
        }
        return result;
    },

    initialize: function() {
        var self = this;
        var title = self.buildSubject('Once', 'Selected');

        self.setScheduleForEdit({
            _id: null,
            id: -1,
            name: title,
            notifications: [{ channel: 'email', details: {
                recipients: LoginService.userObject.email === 'support@vyopta.com' ? '' : LoginService.userObject.email,
                message: self.buildMessage('Once', 'Selected'),
                subject: title} }],
            exportTypes: ['xlsx', 'link'],
            reportingPeriod: 'Selected',
            frequency: 'Once',
            startDate: moment().add(1, 'days').format('YYYY/MM/DD'),
            sendTime: '08:00',
            enabled: true,
            monthOption: 'specifiedDay',
            weekNumber: 1,
            selectedDays: _.range(1,6).map(String),
            monthDayNumber: 1,
            selectedMonthWeek: 1,
            selectedMonthWeekDay: 1
        });
    },

    runScheduleNow: function(scheduleObj) {
        var self = this;

        self.dataProvider.logActivity2('runningExportScheduleNow', 'Schedule Grid', '', scheduleObj);

        var newScheduleObj = _.clone(scheduleObj);

        newScheduleObj.frequency = 'Once';

        newScheduleObj._id = null;
        newScheduleObj.id = new Date().valueOf(); // getNewId();
        newScheduleObj.createdDateTime = new Date();
        newScheduleObj.createdByUserId = "#userId"; //will be replaced by save org prefs
        newScheduleObj.createdByName = LoginService.userObject.name;
        newScheduleObj.createdByEmail = LoginService.userObject.username;
        newScheduleObj.modifiedDateTime = new Date();
        newScheduleObj.modifiedByUserId = "#userId"; //will be replaced by save org prefs
        newScheduleObj.modifiedByName = LoginService.userObject.name;
        newScheduleObj.modifiedByEmail = LoginService.userObject.username;

        self.currentScheduleObject = null;

        self.dataProvider.addExportRegistration(self.appId, { exportRegistration: newScheduleObj });
    },

    enableDisableSchedule: function(scheduleObj) {
        var self = this;
        self.dataProvider.logActivity2('togglingExportSchedule', 'Schedule Grid', '', scheduleObj);
        scheduleObj.enabled = !scheduleObj.enabled;
        self.setScheduleForEdit(scheduleObj);
        self.saveSchedule(true);
        self.editMode = false;
    },

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function() {
        var self = this;
        _.forEach(self.subscriptions, function(sub) {
            sub.dispose();
        });
    }
};

function getDayOptions() {
    return [
        { name: 'Sunday', value: 0 },
        { name: 'Monday', value: 1 },
        { name: 'Tuesday', value: 2 },
        { name: 'Wednesday', value: 3 },
        { name: 'Thursday', value: 4 },
        { name: 'Friday', value: 5 },
        { name: 'Saturday', value: 6 }
    ];
}

function getMonthOptions() {
    return [
        { name: 'January', value: 1 },
        { name: 'February', value: 2 },
        { name: 'March', value: 3 },
        { name: 'April', value: 4 },
        { name: 'May', value: 5 },
        { name: 'June', value: 6 },
        { name: 'July', value: 7 },
        { name: 'August', value: 8 },
        { name: 'September', value: 9 },
        { name: 'October', value: 10 },
        { name: 'November', value: 11 },
        { name: 'December', value: 12 }
    ];
}

function getMonthWeekOptions() {
    return [
        { name: 'First', value: 1 },
        { name: 'Second', value: 2 },
        { name: 'Third', value: 3 },
        { name: 'Fourth', value: 4 },
        { name: 'Fifth', value: 5 },
        { name: 'Last', value: 6 }
    ];
}

function getDateOptions() {
    return [
        { name: '1st', value: 1 }, { name: '2nd', value: 2 }, { name: '3rd', value: 3 }, { name: '4th', value: 4 },
        { name: '5th', value: 5 }, { name: '6th', value: 6 }, { name: '7th', value: 7 }, { name: '8th', value: 8 },
        { name: '9th', value: 9 }, { name: '10th', value: 10 }, { name: '11th', value: 11 }, { name: '12th', value: 12 },
        { name: '13th', value: 13 }, { name: '14th', value: 14 }, { name: '15th', value: 15 }, { name: '16th', value: 16 },
        { name: '17th', value: 17 }, { name: '18th', value: 18 }, { name: '19th', value: 19 }, { name: '20th', value: 20 },
        { name: '21st', value: 21 }, { name: '22nd', value: 22 }, { name: '23rd', value: 23 }, { name: '24th', value: 24 },
        { name: '25th', value: 25 }, { name: '26th', value: 26 }, { name: '27th', value: 27 }, { name: '28th', value: 28 },
        { name: '29th or last', value: 29 }, { name: '30th or last', value: 30 }, { name: '31st or last', value: 31 },
        { name: 'last', value: 32 }
    ];
}

function splitCamelCase(s) {
    return s.split(/(?=[A-Z])/).join(' ');
}

function sanitize(item) {

    return FormatterCommon.sanitize(item);
}

function getCleanUrl() {
    var url = $(location).attr("href");

    var p = url.indexOf('/link/');
    if (p >= 0) {
        url = url.substring(0, p);
    }

    p = url.indexOf('/params/');
    if (p >= 0) {
        url = url.substring(0, p);
    }

    p = url.indexOf('?');
    if (p >= 0) {
        var q = url.indexOf('#');
        url = url.substring(0, p) + url.substring(q);
    }
    return url;
}

function GetObservableParamsList(dashboardDataItem) {
    var list = null;
    if (!_.isEmpty(_.get(dashboardDataItem, 'params.observableParamsList'))) {
        list = _.map(dashboardDataItem.params.observableParamsList, function (item) {
            return ko.unwrap(item);
        });
    }
    return list;
}

function GetOptionToSave(dashboardDataItem, options, obsparams) {
    return {
        x: dashboardDataItem.x,
        y: dashboardDataItem.y,
        componentType: dashboardDataItem.componentType,
        options: CleanUpOptionsForSaving(options),
        observableParams: obsparams,
        seq: dashboardDataItem.seq
    };
}

function CleanUpOptionsForSaving(options) {
    delete options.columnOptions;
    delete options.colOptionsDetail;
    delete options.colOptionsSummary;
    delete options.viewLevelOptions;
    return options;
}

export default { viewModel: ScheduleModal, template: templateMarkup };
